<div class="overlay-header">
  <div class="overlay-logo">Tyler SIS</div>
  <div class="overlay-title"><ng-content></ng-content></div>
  <div class="overlay-close-button">
    <tyl-button id="overlayCloseButton" image="cancel white.png" label="Close" (clickEvent)="closeClick.emit()" *ngIf="showCloseButton">
    </tyl-button>
  <div>
</div>